import { apiService } from '../../../services/apiService';
import { API_PATHS } from '../../../utils/apiPaths';
import { extractApiData } from '../../../utils/helpers';

export async function fetchMerchantDeveloperSettings(merchantId: number | string) {
  const res: unknown = await apiService.get(`${API_PATHS.GET_MERCHANT}/${merchantId}`);
  if ((res as { success?: boolean })?.success === false) {
    throw new Error((res as { message?: string })?.message || 'Unable to load developer settings.');
  }
  const data = extractApiData<Record<string, unknown>>(res);
  if (!data) throw new Error('Unable to load developer settings.');
  return data;
}

export async function updateMerchantDeveloperSettings(payload: Record<string, unknown>) {
  const res: unknown = await apiService.post(API_PATHS.UPDATE_MERCHANT, payload);
  if ((res as { success?: boolean })?.success === false) {
    throw new Error((res as { message?: string })?.message || 'Unable to save developer settings.');
  }
  return extractApiData<Record<string, unknown>>(res);
}
